import axios from 'axios';
import { BASE_URL } from '../constants';

export const getHomepage = (language = 'en', country = 'en') => {
    return axios.get(`${BASE_URL}/pages/homepage`, {
        params: {
            language,
            country,
        },
    });
};
